import React from "react";
import Header from "./layout/header";
import Footer from "./layout/footer";
import ServiceAIBanner from "./service-software-development";
import ServiceAIInfo from "./service-software-info";
function ServiceAI() {
  return (
    <>
<Header/>
<main>
   <ServiceAIBanner/>
<ServiceAIInfo/>
</main>
<Footer/>
</>
  );
}

export default ServiceAI;
